import { useEffect } from 'react';
import { useSelector } from 'react-redux';

// pgw 30-sep-2025 - replace all debugging console.log calls with debugLog
import { debugLog } from './debugLog';


function LocalStorageLogger() {
  useEffect(() => {
    const originalSetItem = localStorage.setItem;

    localStorage.setItem = function (key, value) {

	 if (key.includes('root')) {
		 debugLog('[localStorage.setItem] key = ', key);
	 }
      return originalSetItem.call(this, key, value);
    };

    return () => {
      localStorage.setItem = originalSetItem;
    };
  }, []);

  return null; // doesn't render anything
}

export default LocalStorageLogger;


